import "./App.css";
import Home from "./Home/Home";
import Layout from "./components/Layout";

function App() {
  return (
    <Layout>
      <Home />
    </Layout>
  );
}

export default App;
